module.exports = __webpack_public_path__ + "static/media/note4.092071ff.wav";